import { render, staticRenderFns } from "./ProjectManagementTags.vue?vue&type=template&id=07fa2185&"
import script from "./ProjectManagementTags.vue?vue&type=script&lang=js&"
export * from "./ProjectManagementTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports